import * as Yup from 'yup';
import { getLocalizedStrings } from '../misc';

const FileUplaodSchema = Yup.object().shape({
  registrationFile: Yup.string().required(() => {
    const {
      USERS: {
        BULK_FILE_UPLOAD: {
          ERRORS_MESSAGES: { NO_FILE_SELECTED }
        }
      }
    } = getLocalizedStrings();

    return NO_FILE_SELECTED;
  })
});

export default FileUplaodSchema;
